/** 126 channels: 2400-2525 MHz, 1MHz spacing (nRF24) */
export const NRF_NUM_CHANNELS = 126;

/** Each channel value is 0-NRF_SAMPLES_PER_CH (firmware uses 2) */
export const NRF_SAMPLES_PER_CH = 2;

export interface SpectrumFrame {
  /** Channel power values (0-2 from firmware) */
  channels: Uint8Array;
  /** Timestamp in ms since pendant boot */
  receivedAt: number;
}

export interface WaterfallRow {
  /** RGBA pixel data for one row of the waterfall (4 bytes per pixel) */
  pixels: Uint8ClampedArray;
  timestamp: number;
}
